import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CodigoPergunta, RespostaPergunta } from "app/types/FinalizarOrcamento";
import { resetAll } from "./actions/resetAll";

type RespostasFinalizacaoOrcamento = {[key: CodigoPergunta] : RespostaPergunta}
const initialState: RespostasFinalizacaoOrcamento = {}

export const respostasFinalizacaoOrcamentoSlice = createSlice({
    name: "respostasFinalizacaoOrcamento",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        gravarResposta: (respostasFinalizacaoOrcamento, action: PayloadAction<RespostasFinalizacaoOrcamento>) => {
            const codigoPergunta = Object.keys(action.payload)[0]
            const resposta = action.payload[codigoPergunta]

            respostasFinalizacaoOrcamento[codigoPergunta] = resposta

            return respostasFinalizacaoOrcamento
        },
        limparRespostas: () => {
            return initialState
        }
    }
})

export const {
    gravarResposta: gravarRespostaAction,
    limparRespostas: limparRespostasAction
} : {
    gravarResposta: ActionType<RespostasFinalizacaoOrcamento>
    limparRespostas: ActionType<void>
} = respostasFinalizacaoOrcamentoSlice.actions

export default respostasFinalizacaoOrcamentoSlice.reducer